import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { StorageService } from "src/services/storage.service";
import { Lightbox } from "ngx-lightbox";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { TplService } from "src/services/tpl.service";
import { environment } from "../../../environments/environment";
import { ComprehensiveRequestsService } from "src/services/comprehensive-requests.service";
import { MatLegacyTableDataSource as MatTableDataSource } from "@angular/material/legacy-table";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { ForwardQuoteDialogComponent } from "src/app/forward-quote-dialog/forward-quote-dialog.component";
import { CompanyService } from "src/services/company.service";
import { QuoteStatus } from "src/models/comprehensive-quote";
import { RateCard } from "src/models/rate-card";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-cr-detail",
  templateUrl: "./cr-detail.component.html",
  styleUrls: ["./cr-detail.component.css"],
})
export class CrDetailComponent implements OnInit {
  QuoteStatus = QuoteStatus;
  quoteHistoryDataSource: MatTableDataSource<any>;
  quoteExpiryDate: Date;

  totalComprehensiveAmount = 0;
  showMarkAsApprovedLoader = false;

  // Mandatory Limited Coverage is selected
  showLimitedCoverage = true;

  // Comprehensive
  showComprehensive = true;

  comprehensiveStatus = 0;
  albums: any = [];
  Object = Object;

  SASTokenForUploadCivil: string;
  SASTokenForUploadRCBook: string;

  oldMarketValue: number = 0;

  constructor(
    private lightbox: Lightbox,
    private route: ActivatedRoute,
    protected _sanitizer: DomSanitizer,
    private router: Router,
    private storageService: StorageService,
    private requestService: ComprehensiveRequestsService,
    private location: Location,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<CrDetailComponent>,
    private tplService: TplService,
    private dialog: MatDialog,
    private companyService: CompanyService
  ) {
    const id = +this.route.snapshot.paramMap.get("id");
    if (this.router.getCurrentNavigation()?.extras?.state?.rateCard) {
      this.requestDetails = new RateCard(
        id,
        this.router.getCurrentNavigation()?.extras.state?.rateCard
      );
      this.quoteExpiryDate = new Date(this.requestDetails.createdAt);
      this.quoteExpiryDate.setDate(
        this.quoteExpiryDate.getDate() + this.requestDetails.validityPeriod
      );
    }

    this.requestService.getQuoteRequestByVehicleId(id).subscribe((x) => {
      this.requestDetails = x;
      this.quoteExpiryDate = new Date(this.requestDetails.createdAt);
      this.quoteExpiryDate.setDate(
        this.quoteExpiryDate.getDate() + this.requestDetails.validityPeriod
      );
      this.ngOnInit();
    });
  }

  requestDetails?: RateCard;
  carReadToken: string;
  carUploadToken: string;
  carImagesList: any;
  carVideo: SafeUrl;
  quoteHistory: RateCard[];
  thumbRCBookImageUrl: any;
  thumbCivilFrontImageUrl: any;
  thumbCivilBackImageUrl: any;
  civilFront: string;
  civilBack: string;
  rcBook: string;
  thumbCarFrontImageUrl: string;
  thumbCarBackImageUrl: string;
  thumbCarLeftImageUrl: string;
  thumbCarRightImageUrl: string;
  thumbCarFrontWindShieldImageUrl: string;
  thumbCarChassisImageUrl: string;
  carVideoUrl: string;
  formDisabled: boolean = true;
  companyList: any;
  forwardData: any = {};
  account: any;
  selectedDepartment: any;
  // requestDetails: RateCard;

  qsDisplayedColumns = ["quoteNumber", "submissionDate", "insurer", "status"];

  fiDisplayedColumns = ["insurer", "status"];

  ngOnInit() {
    if (this.requestDetails) {
      // console.log(this.requestDetails);
      this.companyService
        .getCompnayList("Saiyarti")
        .subscribe((companyList) => {
          this.companyList = companyList;
        });

      this.oldMarketValue = this.requestDetails.vehicle.marketValue;

      // Get Car Images
      this.storageService
        .getSASTokenForContainer("comprehensive-car-book")
        .subscribe((carReadToken) => {
          this.carReadToken = carReadToken.sasToken;
          this.thumbCarFrontImageUrl =
            environment.cdnUrl +
            "/comprehensive-car-book/" +
            this.requestDetails.vehicleId +
            "_carFront" +
            this.carReadToken;
          this.thumbCarBackImageUrl =
            environment.cdnUrl +
            "/comprehensive-car-book/" +
            this.requestDetails.vehicleId +
            "_carBack" +
            this.carReadToken;
          this.thumbCarLeftImageUrl =
            environment.cdnUrl +
            "/comprehensive-car-book/" +
            this.requestDetails.vehicleId +
            "_carLeftSide" +
            this.carReadToken;
          this.thumbCarRightImageUrl =
            environment.cdnUrl +
            "/comprehensive-car-book/" +
            this.requestDetails.vehicleId +
            "_carRightSide" +
            this.carReadToken;
          this.thumbCarFrontWindShieldImageUrl =
            environment.cdnUrl +
            "/comprehensive-car-book/" +
            this.requestDetails.vehicleId +
            "_carFrontWSImg" +
            this.carReadToken;
          this.thumbCarChassisImageUrl =
            environment.cdnUrl +
            "/comprehensive-car-book/" +
            this.requestDetails.vehicleId +
            "_carFrontChassisNum" +
            this.carReadToken;
          this.carVideoUrl =
            environment.cdnUrl +
            "/comprehensive-car-book/" +
            this.requestDetails.vehicleId +
            "_carVideo" +
            this.carReadToken;
          this._addAlbum(
            3,
            this.thumbCarFrontImageUrl,
            "Car Front",
            this.thumbCarFrontImageUrl
          );
          this._addAlbum(
            4,
            this.thumbCarBackImageUrl,
            "Car Back",
            this.thumbCarBackImageUrl
          );
          this._addAlbum(
            5,
            this.thumbCarLeftImageUrl,
            "Car Left",
            this.thumbCarLeftImageUrl
          );
          this._addAlbum(
            6,
            this.thumbCarRightImageUrl,
            "Car Right",
            this.thumbCarRightImageUrl
          );
          this._addAlbum(
            7,
            this.thumbCarFrontWindShieldImageUrl,
            "Car Front Windshield",
            this.thumbCarFrontWindShieldImageUrl
          );
          this._addAlbum(
            8,
            this.thumbCarChassisImageUrl,
            "Car Chassis",
            this.thumbCarChassisImageUrl
          );
        });

      this.storageService
        .getUploadOnlyTokenForContainer("comprehensive-car-book")
        .subscribe((carUploadToken) => {
          this.carUploadToken = carUploadToken.sasToken;
        });

      this.storageService
        .getUploadOnlyTokenForContainer("comprehensive-rc-book")
        .subscribe((rcUploadToken) => {
          this.SASTokenForUploadRCBook = rcUploadToken.sasToken;
        });

      this.storageService
        .getUploadOnlyTokenForContainer("comprehensive-civilcard-book")
        .subscribe((civilIdUploadToken) => {
          this.SASTokenForUploadCivil = civilIdUploadToken.sasToken;
        });

      // get Quote History
      this.getQuoteHistory();

      this.civilFront = this.requestDetails.vehicleId + "_front";
      this.civilBack = this.requestDetails.vehicleId + "_back";
      this.rcBook = this.requestDetails.vehicleId.toString();

      // Civil Card Front
      this.storageService
        .getSASToken(this.civilFront, "comprehensive-civilcard-book")
        .subscribe((token: any) => {
          const civilFrontImageUrl =
            environment.cdnUrl +
            "/comprehensive-civilcard-book/" +
            this.civilFront +
            token.sasToken;
          this.thumbCivilFrontImageUrl =
            environment.cdnUrl +
            "/comprehensive-civilcard-book/" +
            this.civilFront +
            token.sasToken;
          const src = civilFrontImageUrl;
          const caption = "Civil Card Front";
          const thumb = this.thumbCivilFrontImageUrl;
          const album = {
            src,
            caption,
            thumb,
          };
          this.albums[0] = album;
        });

      // Civil Card Back
      this.storageService
        .getSASToken(this.civilBack, "comprehensive-civilcard-book")
        .subscribe((token: any) => {
          const civilBackImageUrl =
            environment.cdnUrl +
            "/comprehensive-civilcard-book/" +
            this.civilBack +
            token.sasToken;
          this.thumbCivilBackImageUrl =
            environment.cdnUrl +
            "/comprehensive-civilcard-book/" +
            this.civilBack +
            token.sasToken;
          const src = civilBackImageUrl;
          const caption = "Civil Card Back";
          const thumb = this.thumbCivilBackImageUrl;
          const album = {
            src,
            caption,
            thumb,
          };
          this.albums[1] = album;
        });

      // RC Book
      this.storageService
        .getSASToken(this.rcBook, "comprehensive-rc-book")
        .subscribe((token: any) => {
          const rcBookImageUrl =
            environment.cdnUrl +
            "/comprehensive-rc-book/" +
            this.rcBook +
            token.sasToken;
          this.thumbRCBookImageUrl =
            environment.cdnUrl +
            "/comprehensive-rc-book/" +
            this.rcBook +
            token.sasToken;
          const src = rcBookImageUrl;
          const caption = "RC Book";
          const thumb = this.thumbRCBookImageUrl;
          const album = {
            src,
            caption,
            thumb,
          };
          this.albums[2] = album;
        });
    }
  }

  getQuoteHistory(): void {
    this.requestService
      .getQuoteHistory(this.requestDetails.rateCardId)
      .subscribe((qHList: any) => {
        this.quoteHistory = qHList.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        this.quoteHistoryDataSource = new MatTableDataSource(this.quoteHistory);
      });
  }

  enableEditRequest(): void {
    if (this.requestDetails && this.requestDetails.rateCardId) {
      this.router.navigate(
        [
          "/comprehensive-consumer-request/qh-detail/" +
            this.requestDetails.rateCardId,
        ],
        {
          state: {
            rateCard: this.requestDetails,
          },
          queryParams: {
            canEdit: true,
          },
        }
      );
    }
  }

  open(index: number): void {
    this.lightbox.open(this.albums, index);
  }

  goBack(): void {
    this.location.back();
  }

  updateQuoteDetail() {
    this.recalculateQuote();

    // let updateBody: {
    //   status?: string,
    //   firstName?: string,
    //   lastName?: string,
    //   marketValue?: number,
    //   carTrim?: string,
    //   requestStatus?: string,
    //   notes?: string,
    //   insurerId?: string,
    //   premium?: number,
    //   isForwarded?: boolean
    // } = {
    //   firstName: this.requestDetails.user.firstName,
    //   lastName: this.requestDetails.user.lastName,
    //   carTrim: this.requestDetails.vehicle.carTrim,
    //   marketValue: this.requestDetails.vehicle.marketValue,
    //   requestStatus: QuoteStatus.UPDATED_REQUEST,
    //   status: this.requestDetails.status,
    //   premium: this.totalComprehensiveAmount,
    //   isForwarded: true
    // }

    // if (this.requestDetails.requestStatus == QuoteStatus.REJECTED || this.requestDetails.requestStatus == QuoteStatus.APPROVED) {
    //   updateBody.requestStatus = this.requestDetails.requestStatus;
    //   updateBody.status = this.requestDetails.requestStatus;
    // }

    this.requestService
      .updateRequestOfCustomer(
        this.requestDetails.rateCardId,
        this.requestDetails
      )
      .subscribe(
        () => {
          this.snackBar.open("Details are updated successfully.", "OK", {
            horizontalPosition: "center",
            duration: 2000,
          });
          this.getQuoteHistory();
          this.formDisabled = true;
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
          });
        }
      );
  }

  recalculateQuote(): void {
    // Reset all values
    this.totalComprehensiveAmount = 0;

    if (Object.keys(this.requestDetails.parametersMap).length == 0) {
      this.showComprehensive = false;
    }

    // Mandatory Limited Coverage is selected
    if (this.showLimitedCoverage) {
      this.calculateLimitedCoverage();
    }

    // Comprehensive is Selected
    if (this.showComprehensive) {
      this.calculateComprehensive();
    }
    //this.requestDetails.amount = this.totalComprehensiveAmount;
  }

  private calculateLimitedCoverage() {
    if (this.showComprehensive === false) {
      const minimumPremiumAmount = this.requestDetails.minimumPremiumAmount;

      var amountToAdd = 0;
      for (let index = 0; index < this.requestDetails.fees.length; index++) {
        const fee = this.requestDetails.fees[index];
        amountToAdd += fee.amount;
      }

      this.totalComprehensiveAmount +=
        (this.requestDetails.vehicle.marketValue *
          this.requestDetails.limitedComprehensiveCover) /
        100;
      if (this.totalComprehensiveAmount < minimumPremiumAmount) {
        this.totalComprehensiveAmount = minimumPremiumAmount;
      }
      this.totalComprehensiveAmount += amountToAdd;
      this.totalComprehensiveAmount = +this.totalComprehensiveAmount.toFixed(3);
    }
  }

  private calculateComprehensive() {
    let i = 0;
    // Loop over parameters for each insurance company to calculate total comprehensive amount

    // Extract the variables needed for further calculations
    const saiyartiPercentage = this.requestDetails.saiyartiPercentage;
    const insurerPercentage = this.requestDetails.insurerPercentage;
    const minimumPremiumAmount = this.requestDetails.minimumPremiumAmount;

    var fees = 0;
    for (let index = 0; index < this.requestDetails.fees.length; index++) {
      const fee = this.requestDetails.fees[index];
      fees += fee.amount;
    }

    var premium = 0;
    var comprehensivePercentage = saiyartiPercentage + insurerPercentage;
    // Calculate the premium based on the subLimit and KD values
    // For Waiver of Subrogation use KD values
    // For anything else with subLimit use their percentage values
    for (const key in this.requestDetails.parametersMap) {
      var parameter = this.requestDetails.parametersMap[key];

      if (parameter.name === "Waiver of Subrogation") {
        for (const key in parameter.subParametersMap) {
          const subParameter = parameter.subParametersMap[key];
          if (subParameter.isSelected) {
            premium += +subParameter.valueForInsurer;
          }
        }
      } else {
        for (const key in parameter.subParametersMap) {
          const subParameter = parameter.subParametersMap[key];
          if (subParameter.isSelected) {
            comprehensivePercentage -= +subParameter.percentageValue;
          }
        }
      }
    }

    premium +=
      (+comprehensivePercentage * this.requestDetails.vehicle.marketValue) /
      100.0;
    // If the premium is less than minimum premium amount
    // for the insurance company use the minimumPremiumAmount
    if (premium < minimumPremiumAmount) {
      premium = minimumPremiumAmount;
    }

    // Add premium & fees to final amount
    this.totalComprehensiveAmount += premium + fees;
    this.totalComprehensiveAmount = +this.totalComprehensiveAmount.toFixed(3);
  }

  getRateCardValue(rateCard: RateCard): any {
    let bRetVal = "";
    if (rateCard) {
      for (const key in rateCard.parametersMap) {
        var parameter = rateCard.parametersMap[key];
        if (parameter.isSelected) {
          bRetVal = parameter.name;
          break;
        }
      }
    } else {
      return "Included";
    }
    return bRetVal;
  }

  downloadQuotePDF(): void {
    window.open(
      `${environment.cdnUrl}/comprehensive-invoice/${this.requestDetails.rateCardId}.pdf`,
      "_blank"
    );
  }

  downloadInsurerQuotePDF(): void {
    window.open(
      `${environment.cdnUrl}/comprehensive-invoice/insurer-${this.requestDetails.rateCardId}.pdf`,
      "_blank"
    );
  }

  forwardToInsurer(): void {
    let insurer = this.companyList.find(
      (company) => company.id == this.forwardData.insurerId
    );
    if (insurer) {
      let dialogData = {
        insurerName: insurer.companyName,
        email: insurer.emails,
      };
      const forwardDialogRef = this.dialog.open(ForwardQuoteDialogComponent, {
        disableClose: true,
        data: dialogData,
      });

      forwardDialogRef.afterClosed().subscribe((result) => {
        if (result == "true") {
          this.requestDetails.forwardedToInsurer = {
            insurerId: insurer.id,
            name: insurer.companyName,
          };
          this.requestDetails.notes = this.forwardData.notes;
          this.requestService
            .rateCardForwarded(this.requestDetails.id, this.requestDetails)
            .subscribe(
              (result) => {
                this.snackBar.open(
                  "Quote forward history saved for " + insurer.companyName,
                  "OK",
                  {
                    horizontalPosition: "right",
                    duration: 2000,
                  }
                );

                // get Quote History
                this.getQuoteHistory();
              },
              (error) => {
                this.snackBar.open(error, "CANCEL", {
                  horizontalPosition: "right",
                  duration: 2000,
                });
              }
            );
        }
      });
    }
  }

  approveRateCard(): void {
    this.showMarkAsApprovedLoader = true;
    this.requestService.approveRateCard(this.requestDetails.id).subscribe(
      (result) => {
        this.showMarkAsApprovedLoader = false;
        this.snackBar.open("Quote has been marked as approved", "OK", {
          horizontalPosition: "right",
          duration: 2000,
        });

        // get Quote History
        this.getQuoteHistory();
      },
      (error) => {
        this.showMarkAsApprovedLoader = false;
        this.snackBar.open(error, "CANCEL", {
          horizontalPosition: "right",
          duration: 2000,
        });
      }
    );
  }

  rejectRateCard(): void {
    this.requestService.rejectRateCard(this.requestDetails.id).subscribe(
      (result) => {
        this.snackBar.open("The customer's request has been denied.", "OK", {
          horizontalPosition: "right",
          duration: 2000,
        });

        // get Quote History
        this.getQuoteHistory();
        this.requestDetails.status = QuoteStatus.REJECTED;
      },
      (error) => {
        this.snackBar.open(error, "CANCEL", {
          horizontalPosition: "right",
          duration: 2000,
        });
      }
    );
  }

  approvedByInsurer(): void {
    this.requestDetails.insurer = {
      insurerId: this.requestDetails.forwardedToInsurer.insurerId,
      name: this.requestDetails.forwardedToInsurer.name,
    };
    this.requestDetails.forwardedToInsurer = undefined;

    this.requestService
      .updateRequestOfCustomer(this.requestDetails.id, this.requestDetails)
      .subscribe(
        (result) => {
          this.snackBar.open("Quote has been marked as forwarded", "OK", {
            horizontalPosition: "right",
            duration: 2000,
          });

          // get Quote History
          this.getQuoteHistory();
        },
        (error) => {
          this.snackBar.open(error, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        }
      );
  }

  uploadPolicy() {
    if (this.requestDetails.status == QuoteStatus.PAYMENT_RECEIVED) {
      this.router.navigate([
        "/comprehensive-consumer-request",
        "policy-info",
        this.requestDetails.id,
      ]);
    }
  }

  openQuoteHistory(rateCard: RateCard) {
    if (rateCard && rateCard.historyId) {
      this.router.navigate(
        ["/comprehensive-consumer-request/qh-detail/" + rateCard.historyId],
        {
          state: {
            rateCard: rateCard,
          },
        }
      );
    }
  }

  uploadDoc(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    if (file !== undefined) {
      if (
        event.srcElement.id === "civilCardFront" ||
        event.srcElement.id === "civilCardBack"
      ) {
        if (event.srcElement.id === "civilCardFront") {
          reader.onload = (e: any) => {
            this.thumbCivilFrontImageUrl = e.target.result;
          };
        } else {
          reader.onload = (e: any) => {
            this.thumbCivilBackImageUrl = e.target.result;
          };
        }
        const fileName =
          this.requestDetails.vehicleId +
          (event.srcElement.id === "civilCardFront" ? "_front" : "_back");
        this.storageService
          .getUploadOnlyTokenForContainer("comprehensive-civilcard-book")
          .subscribe((token) => {
            this.storageService
              .uploadFileToAzure(
                `/comprehensive-civilcard-book/${fileName}${token.sasToken}`,
                file,
                "image/jpg"
              )
              .subscribe({
                next: () => {},
              });
          });
      } else if (event.srcElement.id === "rcBook") {
        reader.onload = (e: any) => {
          this.thumbRCBookImageUrl = e.target.result;
        };
        this.storageService
          .getUploadOnlyTokenForContainer("comprehensive-rc-book")
          .subscribe((token) => {
            this.storageService
              .uploadFileToAzure(
                `/comprehensive-rc-book/${this.requestDetails.vehicleId}${token.sasToken}`,
                file,
                "image/jpg"
              )
              .subscribe({
                next: () => {},
              });
          });
      } else {
        let fileName = `${this.requestDetails.vehicleId}`;
        if (event.srcElement.id === "carFront") {
          fileName += "_carFront";
          reader.onload = (e: any) => {
            this.thumbCarFrontImageUrl = e.target.result;
          };
        } else if (event.srcElement.id === "carBack") {
          fileName += "_carBack";
          reader.onload = (e: any) => {
            this.thumbCarBackImageUrl = e.target.result;
          };
        } else if (event.srcElement.id === "carLeft") {
          fileName += "_carLeftSide";
          reader.onload = (e: any) => {
            this.thumbCarLeftImageUrl = e.target.result;
          };
        } else if (event.srcElement.id === "carRight") {
          fileName += "_carRightSide";
          reader.onload = (e: any) => {
            this.thumbCarRightImageUrl = e.target.result;
          };
        } else if (event.srcElement.id === "carFrontWindShield") {
          fileName += "_carFrontWSImg";
          reader.onload = (e: any) => {
            this.thumbCarFrontWindShieldImageUrl = e.target.result;
          };
        } else if (event.srcElement.id === "carChassis") {
          fileName += "_carFrontChassisNum";
          reader.onload = (e: any) => {
            this.thumbCarChassisImageUrl = e.target.result;
          };
        } else if (event.srcElement.id === "carVideo") {
          fileName += "_carVideo";
          reader.onload = (e: any) => {
            this.carVideoUrl = e.target.result;
          };
        }
        reader.readAsDataURL(file);
        this.storageService
          .getUploadOnlyTokenForContainer("comprehensive-car-book")
          .subscribe((token) => {
            this.storageService
              .uploadFileToAzure(
                `/comprehensive-car-book/${fileName}${token.sasToken}`,
                file,
                "image/jpg"
              )
              .subscribe({
                next: () => {},
              });
          });
      }

      reader.readAsDataURL(file);
    }
  }
  _addAlbum(index: number, src: string, caption: string, thumb: string): void {
    const album = {
      src,
      caption,
      thumb,
    };
    this.albums[index] = album;
  }

  updateComprehensiveQuote() {
    const id = this.requestDetails?.id;
    this.router.navigate(
      ["comprehensive-consumer-request/cr-detail/" + id + "/update-quote"],
      { state: { vehicleDetail: this.requestDetails.vehicle } }
    );
  }
}
